import axios from "axios";

const state = {
  states: [],
};

const mutations = {
  setStates(state, data) {
    state.states = data;
  },
};

const actions = {
  saveStates({ commit, rootState }) {
    if (rootState.system.isOffline) return;
    let stateData = {
      trans_from: rootState.system.trans_from,
      country_id: rootState.system.country_details.country_id,
      url: "/location/get-state",
    };
    axios.post(stateData.url, stateData).then((res) => {
      commit("setStates", res.data.data);
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
